import { api } from '../core';
import { BUNDLE_SEARCH_TAG } from '../constants';
import { RootState, setBundleSearchResults } from '@/store';

interface ResultsPerPage {
  [pageId: string]: number;
}

export interface BundleSearchResponse {
  pageIds: string[];
  resultsPerPage: ResultsPerPage;
}

type GetBundleSearchProps = {
  bundleId: string;
  searchTerm: string;
  abortController?: AbortController;
};

const getBundleSearchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleSearch: builder.query<BundleSearchResponse, GetBundleSearchProps>({
      query: ({ bundleId, searchTerm, abortController = new AbortController() }: GetBundleSearchProps) => ({
        url: `bundle/search?bundle_id=${bundleId}&search_term=${searchTerm}`,
        method: 'GET',
        signal: abortController.signal
      }),
      providesTags: (
        _result: BundleSearchResponse | undefined,
        _err: unknown,
        { bundleId, searchTerm }: GetBundleSearchProps
      ) => [{ type: BUNDLE_SEARCH_TAG, id: bundleId, searchTerm: searchTerm }],
      async onQueryStarted(_arg: GetBundleSearchProps, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;

          if (data?.pageIds && data?.resultsPerPage && state.sharedData.activeBundleType) {
            dispatch(
              setBundleSearchResults({
                key: state.sharedData.activeBundleType,
                data: data
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundleSections in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleSearchQuery } = getBundleSearchApi;
